<template>
  <div>
    <el-dialog
      append-to-body
      :title="`无码退货(单号:${goodsreturn.code})`"
      :visible.sync="visible"
      width="840px"
      :close-on-press-escape="false">
      <el-form
        ref="ruleForm"
        :rules="rules"
        label-position="top"
        :model="goodsreturn"
        label-width="80px">
        <el-form-item
          label="退货仓库:"
          prop="warehouseNo">
          <el-input
            v-model="goodsreturn.warehouseName"
            readonly="">
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="selectWarehouse"></el-button>
          </el-input>
        </el-form-item>
        <el-form-item
          label-width="0"
          prop="detailList">
          <el-table
            v-if="goodsreturn.type === 1"
            v-loading="loading"
            :data="goodsreturn.detailList"
            border>
            <el-table-column
              label="商品名称"
              prop="skuName"></el-table-column>
            <el-table-column
              width="80"
              label="商品编码"
              prop="skuCode"></el-table-column>
            <el-table-column
              label="下单数量"
              width="80"
              :resizable="false"
              prop="num">
              <template slot-scope="{row}">{{ row.num }} {{ row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
            <el-table-column
              label="出库数量"
              width="80"
              :resizable="false"
              prop="outNum">
              <template slot-scope="{row}">{{ row.outNum }} {{ row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
            <el-table-column
              label="已退数量"
              width="80"
              :resizable="false"
              prop="refundNum">
              <template slot-scope="{row}">{{ row.refundNum }} {{ row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
            <el-table-column
              label="本次无码退货数量"
              min-width="120">
              <template slot-scope="{row,$index}">
                <el-input-number
                  v-model="goodsreturn.detailList[$index].returnGoodsCount"
                  style="width:100%"
                  :precision="0"
                  :max="row.canReturnGoodsCount"
                  :min="0"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column
              label="批次号"
              min-width="110">
              <template slot-scope="{row, $index}">
                <el-input
                  v-if="row.productType === 3"
                  v-model="goodsreturn.detailList[$index].lotNumber"
                  style="width:100%"></el-input>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-if="goodsreturn.type === 2"
            v-loading="loading"
            :data="goodsreturn.detailList"
            border>
            <el-table-column
              label="商品名称"
              prop="productName"></el-table-column>
            <el-table-column
              label="商品编码"
              width="80"
              :resizable="false"
              prop="productNumber">
            </el-table-column>
            <el-table-column
              label="下单数量"
              width="80"
              :resizable="false"
              prop="goodsCount">
              <template slot-scope="{row}">{{ row.goodsCount }} {{ row.measureUnit | measureUnitName() }}</template>
            </el-table-column>
            <el-table-column
              label="已退数量"
              width="80"
              :resizable="false"
              prop="goodsCount">
              <template slot-scope="{row}">
                {{ row.returnedGoodsCount }} {{ row.measureUnit | measureUnitName() }}
              </template>
            </el-table-column>
            <el-table-column
              label="本次无码退货数量"
              min-width="120">
              <template slot-scope="{row,$index}">
                <el-input-number
                  v-model="goodsreturn.detailList[$index].returnGoodsCount"
                  style="width:100%"
                  :precision="0"
                  :max="row.canReturnGoodsCount"
                  :min="0"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <warehouse-select-modal
        ref="warehouse"
        :callback="warehouseCallback" />
      <span
        slot="footer"
        class="dialog-footer">
        <el-button
          :loading="loading"
          @click="toggleModal(false)">取 消</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import WarehouseSelectModal from '../../orders/busi/warehouse-select-modal.vue'
export default {
  name: 'NotagReturenModal',
  components: { WarehouseSelectModal },
  props: {
    fetch: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      goodsreturn: {
        type: 1,
        detailList: []
      },
      rules: {
        warehouseNo: [{ required: true, message: '请选择仓库', trigger: 'change' }]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
      if (!visible) {
        this.goodsreturn = {
          detailList: []
        }
      }
    },
    selectWarehouse() {
      this.$refs.warehouse.fetch({
        productType: 1, useType: 1
        // productIds: this.orderInfo.detailList.map(i => i.skuId)
      })
    },
    warehouseCallback(row) {
      this.goodsreturn.warehouseNo = row.warehouseNo
      this.goodsreturn.warehouseName = row.warehouseName
    },
    init(info) {
      const type = info.type
      this.getproducts((idList) => {
        if (type === 1) {
          this.goodsreturn = {
            ...this.goodsreturn,
            ...info,
            detailList: info.detailList.map(i => {
              return {
                ...i,
                productType: idList.indexOf(i.skuId) > -1 ? 3 : -1,
                returnGoodsCount: 0,
                lotNumber: '',
                canReturnGoodsCount: i.realOutNum - (i.refundNum || 0)
              }
            })
          }
        }
        if (type === 2) {
          this.goodsreturn = {
            ...this.goodsreturn,
            ...info,
            detailList: info.detailList.map(i => {
              return {
                ...i,
                productType: -1,
                returnGoodsCount: 0,
                lotNumber: '',
                canReturnGoodsCount: i.goodsCount - i.returnedGoodsCount
              }
            })
          }
        }
        this.toggleModal(true)
      })
    },
    getproducts(cb) {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: { 'pageNum': 1, 'pageSize': 1000, 'productTypes': [3], 'status': 2 },
        success: (res) => {
          console.log(res)
          this.loading = false
          cb && cb(res.data.records.map(i => i.productId))
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleSubmit() {
      const goodsReturnItems = this.goodsreturn.detailList.filter(i => i.returnGoodsCount > 0)
      if (goodsReturnItems.length === 0) {
        this.$message.error('至少有一个商品的本次无码退货数量大于0')
        return
      }
      if (this.goodsreturn.type === 1) {
        const isLotNumber = this.goodsreturn.detailList.some(i => i.productType === 3 && !i.lotNumber)
        if (isLotNumber) {
          this.$message.error('散茶商品的批次号不能为空')
          return
        }
      }

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('goodsreturn/addgoodsreturnbynotag', {
            payload: {
              vendorId: this.goodsreturn.vendorId,
              dealOrderCode: this.goodsreturn.code,
              warehouseNo: this.goodsreturn.warehouseNo,
              billType: this.goodsreturn.type,
              postSaleOrderNumber: this.goodsreturn.postSaleOrderNumber,
              goodsReturnItems: goodsReturnItems.map(i => ({ lotNumber: i.lotNumber, productId: i.skuId || i.productId, returnGoodsCount: i.returnGoodsCount }))
            },
            success: () => {
              this.loading = false
              this.fetch && this.fetch()
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
